import { LocalDate, nativeJs } from "@js-joda/core";

//! @ngInject
export function hhaxIntegrationService($rootScope, $http, Consts) { return {
    getPatientFiles: (dateRecordTimes, integrationDatePicker, selectedOffices, selectedPayers, selectedStatus) => {
      const baseUrl = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_patient_dem`;
      const url = buildNonBillingIntegrationUrl(baseUrl, dateRecordTimes, integrationDatePicker, selectedOffices, selectedPayers, selectedStatus);

      return $http.get(url);
    },

    getAuthorizationFiles: (dateRecordTimes, integrationDatePicker, selectedOffices, selectedPayers, selectedStatus) => {
      const baseUrl = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_authorization`;
      const url = buildNonBillingIntegrationUrl(baseUrl, dateRecordTimes, integrationDatePicker, selectedOffices, selectedPayers, selectedStatus);

      return $http.get(url);
    },

    getPOCFiles: (dateRecordTimes, integrationDatePicker, selectedOffices, selectedPayers, selectedStatus) => {
      const baseUrl = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_poc`;
      const url = buildNonBillingIntegrationUrl(baseUrl, dateRecordTimes, integrationDatePicker, selectedOffices, selectedPayers, selectedStatus);

      return $http.get(url);
    },

    getUnlinkedPatients: () => {
      const url = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_unlinked_patients`;
      return $http.get(url);
    },

    processRecords: (recordsIds, fileType, markType) => {
      const url = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_mark_records`;

        return $http.patch(url, {
          records: recordsIds,
          fileType: fileType,
          markType: markType,
        });
    },

    getHHAXIntegrationPayers: () => {
      return $http.get(`${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_payers`).then(res => {
          return res.data;
      });
    },

    getResponseFileRejections: (dates, selectedOffices, selectedContracts) => {
      const baseUrl = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_response_file_rejections`;
      const url = buildBillingIntegrationURL(baseUrl, dates, selectedOffices, selectedContracts);

      return $http.get(url).then(res => {
        return res.data;
      });
    },

    getBillingExceptions: (dates, selectedOffices, selectedContracts) => {
      const baseUrl = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_billing_exceptions`;
      const url = buildBillingIntegrationURL(baseUrl, dates, selectedOffices, selectedContracts);

      return $http.get(url).then(res => {
        return res.data;
      });
    },

    getPreAdjRejections: (dates, selectedOffices, selectedContracts) => {
      const baseUrl = `${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_pre_adj_rejections`;
      const url = buildBillingIntegrationURL(baseUrl, dates, selectedOffices, selectedContracts);

      return $http.get(url).then(res => {
        return res.data;
      });
    },

    getHHAXIntegrationAuthRecordExtra: (hhaIntegrationAuthRecordId) => {
      return $http.get(`${Consts.api}agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/hhax_integration_authorization/${hhaIntegrationAuthRecordId}`).then(res => {
          return {
            recordServiceCodeIds: res.data.serviceCodeIds,
            recordContractTypesIds: res.data.contractTypesIds
          };
      });
    },
  } };

const buildNonBillingIntegrationUrl = (baseUrl, dateRecordTimes, integrationDatePicker, selectedOffices, selectedPayers, selectedStatus) => {
  const fromParam = LocalDate.from(nativeJs(integrationDatePicker.from));

  const toParam = LocalDate.from(nativeJs(integrationDatePicker.to));

  let url = `${baseUrl}?date_record_times=${dateRecordTimes}&from=${fromParam}&to=${toParam}`;

  if (selectedOffices.length > 0) {
    url = url.concat(`&offices=${selectedOffices.map(({ id }) => id).join("|")}`);
  }
  if (selectedPayers.length > 0) {
    url = url.concat(`&payers=${selectedPayers.map(({ id }) => id).join("|")}`);
  }
  if (selectedStatus.length > 0) {
    url = url.concat(`&record_status=${selectedStatus.map(({ id }) => id).join("|")}`);
  }

  

  return url;
}

const buildBillingIntegrationURL = (baseUrl, dates, selectedOffices, selectedContracts) => {
  const fromParam = LocalDate.from(nativeJs(dates.from));

  const toParam = LocalDate.from(nativeJs(dates.to));

  let url = `${baseUrl}?from=${fromParam}&to=${toParam}`;

  if (selectedOffices.length > 0) {
    url = url.concat(`&offices=${selectedOffices.map(({ id }) => id).join("|")}`);
  }
  if (selectedContracts.length > 0) {
    url = url.concat(`&contracts=${selectedContracts.map(({ id }) => id).join("|")}`);
  }

  return url;
}
